import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, Coins, Menu, LogOut } from 'lucide-react';
import { useAppState } from '../../context/AppStateContext';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { id: 'home', path: '/home', icon: Home, label: 'Home' },
  { id: 'groups', path: '/groups', icon: Users, label: 'Groups' },
  { id: 'dashboard', path: '/dashboard', icon: Coins, label: 'Rewards' },
  { id: 'menu', path: '/menu', icon: Menu, label: 'Settings' },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedGroup, setMenuScreen, profileForm } = useAppState();
  const { logout } = useAuth();

  const handleTabChange = (item) => {
    if (item.id !== 'groups') {
      setSelectedGroup(null);
    }
    if (item.id !== 'menu') {
      setMenuScreen(null);
    }
    navigate(item.path);
  };

  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-white border-r border-gray-200 flex flex-col z-40">
      {/* Logo - clickable to go home */}
      <div className="p-6 border-b border-gray-100">
        <button
          onClick={() => navigate('/home')}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
        >
          <img src="/logo/bonndleLogoIcon_Indigo.svg" alt="Bonndle" className="w-10 h-10" />
          <img src="/logo/bonndleLogoWordmark_Indigo.svg" alt="Bonndle" className="h-[17px]" />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => handleTabChange(item)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'bg-indigo-50 text-indigo-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              <span className={`${isActive ? 'font-bold' : 'font-medium'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-100">
        <button
          onClick={() => {
            logout();
            navigate('/');
          }}
          className="w-full flex items-center gap-2 px-4 py-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut size={18} />
          <span className="text-sm font-medium">Logout</span>
        </button>
      </div>
    </aside>
  );
}
